<template>
  <div class="sourceManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-sourceManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">来源管理</span>
              <el-button
                type="primary"
                size="small"
                class="pull-right"
                @click="handAdd"
              >
                新增来源
              </el-button>
            </div>
          </div>

          <div class="activitiesManage-container">
            <div class="content">
              <div class="flex-al Inquire-box mb10">
                <el-select
                  v-model="filter.community_type"
                  clearable
                  placeholder="请选择来源类型"
                  class="mr10"
                  style="width: 180px"
                  @change="search"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="小区" value="0"></el-option>
                  <el-option label="商场" value="1"></el-option>
                </el-select>
                <el-input
                  v-model.trim="filter.keyword"
                  clearable
                  placeholder="请输入来源名称"
                  class="input-cont"
                  style="width: 260px"
                  @clear="search"
                  @keyup.enter.native="search"
                ></el-input>
                <el-button type="primary" class="btn-inquire" @click="search">
                  查询
                </el-button>
              </div>

              <div ref="auto_height_table" class="tableList">
                <normalTableCont ref="multipleTable" :tableData="tableList">
                  <el-table-column
                    label="操作"
                    align="center"
                    width="150px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="handEdit(scope.row)">
                        编辑
                      </el-button>
                      <el-button type="text" size="small" @click="handDelete(scope.row)">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </normalTableCont>
              </div>

              <el-pagination
                style="margin-top: 35px"
                :current-page="paging.curPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="paging.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paging.pageTotal"
                @size-change="pageSizeChange"
                @current-change="curPageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>

      <el-dialog
        :title="propData.isEdit ? '编辑来源' : '新增来源'"
        :visible.sync="propData.cancelVisible"
        width="560px"
        :before-close="handleClose"
        @closed="resetForm"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="130px"
        >
          <el-form-item label="来源名称：" prop="community_name">
            <el-input
              v-model.trim="ruleForm.community_name"
              :disabled="isUsedSource"
              maxlength="30"
              placeholder="如：翡翠湾小区/万达广场"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="距校距离(km)：" prop="community_distance">
            <el-input-number
              v-model="ruleForm.community_distance"
              :precision="2"
              :min="0"
              :step="0.01"
              placeholder="如：0.8"
              style="width: 320px"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="来源类型：" prop="community_type">
            <el-select
              v-model="ruleForm.community_type"
              placeholder="请选择来源类型"
              style="width: 320px"
            >
              <el-option label="小区" value="0"></el-option>
              <el-option label="商场" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址：" prop="community_address">
            <el-input
              v-model.trim="ruleForm.community_address"
              :disabled="isUsedSource"
              maxlength="200"
              placeholder="如：高新区望江路18号"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.community_type === '0'"
            label="预估入住户数："
            prop="community_resident"
          >
            <el-input
              v-model="ruleForm.community_resident"
              maxlength="10"
              placeholder="如：1200"
              style="width: 320px"
              @input="handleResidentInput"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="submitForm">
            确定
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="删除"
        :visible.sync="delItem"
        width="420px"
        :close-on-click-modal="false"
      >
        <span>操作不可撤回，确定删除吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="delItem = false">取消</el-button>
          <el-button type="primary" :loading="deleting" @click="handleDel">
            确定
          </el-button>
        </span>
      </el-dialog>
    </PageNav>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import normalTableCont from "../../components/tables/normalTableCont.vue";

function createDefaultForm() {
  return {
    community_type: "0",
    community_name: "",
    community_address: "",
    community_distance: undefined,
    community_resident: "",
    community_note: "",
    community_id: "",
    community_isuse: "",
  };
}

export default {
  name: "sourceManage",
  components: {
    PageNav,
    normalTableCont,
  },
  data() {
    return {
      slider: [],
      openMenu: ["3"],
      filter: {
        community_type: "",
        keyword: "",
      },
      ruleForm: createDefaultForm(),
      rules: {
        community_type: [
          { required: true, message: "请选择来源类型", trigger: "change" },
        ],
        community_name: [
          { required: true, message: "请输入来源名称", trigger: "blur" },
        ],
      },
      tableList: {
        columns: [],
        list: [],
        options: {
          errortip: "",
          mutiSelect: false,
          issetting: false,
          tableHeight: 0,
        },
      },
      paging: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      propData: {
        cancelVisible: false,
        isEdit: false,
      },
      delItem: false,
      delInfo: {},
      submitting: false,
      deleting: false,
    };
  },
  computed: {
    isUsedSource() {
      return this.propData.isEdit && String(this.ruleForm.community_isuse) === "1";
    },
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.getSchoolcommunityList();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.auto_height_table) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 90
        );
      }
    });
  },
  methods: {
    isSuccess(code) {
      return code === 200 || code === 1;
    },
    getSchoolcommunityList() {
      return this.$http
        .getSchoolcommunityList({
          keyword: this.filter.keyword,
          community_type: this.filter.community_type,
          p: this.paging.curPage,
          num: this.paging.pageSize,
          is_count: 1,
        })
        .then((res) => {
          const response = res.data || {};
          const body = response.data || {};
          this.tableList.columns = Array.isArray(body.field) ? body.field : [];
          this.tableList.options.errortip = response.msg || "";
          if (this.isSuccess(response.code)) {
            this.tableList.list = Array.isArray(body.list) ? body.list : [];
            this.paging.pageTotal = Number(body.allnum) || 0;
          } else {
            this.tableList.list = [];
            this.paging.pageTotal = 0;
          }
        });
    },
    search() {
      this.paging.curPage = 1;
      this.getSchoolcommunityList();
    },
    handAdd() {
      this.propData.isEdit = false;
      this.ruleForm = createDefaultForm();
      this.propData.cancelVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handEdit(row) {
      this.propData.isEdit = true;
      this.ruleForm = Object.assign(createDefaultForm(), row, {
        community_type: String(row.community_type == null ? "0" : row.community_type),
        community_distance:
          row.community_distance == null || row.community_distance === ""
            ? undefined
            : Number(row.community_distance),
        community_resident:
          row.community_resident == null ||
          row.community_resident === "" ||
          row.community_resident === "--"
            ? ""
            : String(row.community_resident),
      });
      this.propData.cancelVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid || this.submitting) {
          return;
        }
        const method = this.propData.isEdit
          ? "editSchoolcommunityAction"
          : "addSchoolcommunityAction";
        const params = this.getSubmitParams();
        this.submitting = true;
        this.$http[method](params)
          .then((res) => {
            const response = res.data || {};
            const success = this.isSuccess(response.code);
            this.$message({
              message: response.msg || (success ? "操作成功" : "操作失败"),
              type: success ? "success" : "error",
            });
            if (success) {
              this.propData.cancelVisible = false;
              this.getSchoolcommunityList();
            }
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    getSubmitParams() {
      const params = {
        community_type: this.ruleForm.community_type,
        community_name: this.ruleForm.community_name,
        community_address: this.ruleForm.community_address,
        community_distance:
          this.ruleForm.community_distance == null
            ? ""
            : this.ruleForm.community_distance,
        community_resident:
          this.ruleForm.community_type === "0" ? this.ruleForm.community_resident : "",
        community_note: this.ruleForm.community_note || "",
      };
      if (this.propData.isEdit) {
        params.community_id = this.ruleForm.community_id;
      }
      return params;
    },
    handleResidentInput(value) {
      this.ruleForm.community_resident = String(value || "").replace(/[^\d]/g, "");
    },
    handDelete(row) {
      this.delInfo = row;
      this.delItem = true;
    },
    handleDel() {
      if (!this.delInfo.community_id || this.deleting) {
        return;
      }
      this.deleting = true;
      this.$http
        .delSchoolcommunityAction({
          community_id: this.delInfo.community_id,
        })
        .then((res) => {
          const response = res.data || {};
          const success = this.isSuccess(response.code);
          this.$message({
            message: response.msg || (success ? "删除成功" : "删除失败"),
            type: success ? "success" : "error",
          });
          if (success) {
            this.delItem = false;
            if (this.tableList.list.length === 1 && this.paging.curPage > 1) {
              this.paging.curPage -= 1;
            }
            this.getSchoolcommunityList();
          }
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    handleClose() {
      this.propData.cancelVisible = false;
    },
    resetForm() {
      this.ruleForm = createDefaultForm();
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
    },
    curPageChange(value) {
      this.paging.curPage = value;
      this.getSchoolcommunityList();
    },
    pageSizeChange(value) {
      this.paging.pageSize = value;
      this.paging.curPage = 1;
      this.getSchoolcommunityList();
    },
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");

.sourceManage {
  .head-nav {
    line-height: 32px;
  }

  .activitiesManage-container .content {
    padding: 20px;
  }
}
</style>
